/**
 * Detects if an email address contains comma-separated list of emails
 * Returns true if the email contains commas (indicating multiple emails)
 */
export function isMultipleEmailsInOne(email: string): boolean {
  return email.includes(',');
}

/**
 * Splits a comma-separated email string into individual emails
 * Returns array of email addresses
 */
export function splitEmails(email: string): string[] {
  return email
    .split(',')
    .map((e) => e.trim())
    .filter((e) => e.length > 0);
}

/**
 * Validates that a string is a valid email format
 */
export function isValidEmail(email: string): boolean {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}
